import React, {useState} from "react";
import {useMutation, useQuery} from "@apollo/client";
import {useParams, useNavigate} from "react-router-dom";
import {Button, Col, Container, Row} from "react-bootstrap";
import FlashMessage from "../../shared/FlashMessage";
import {saveData} from "../../../helpers/Api";
import {createCategoryMutation, getCategories, getCategoryById, updateCategoryMutation} from "./CategoryQueries";
import {BackButton} from "../../../helpers/ButtonHelper";
import PageTitle from "../../../layout/PageTitle";

const CategoryForm = () => {
  const navigate = useNavigate();
  const params = useParams();
  const [flash, setFlash] = useState({});
  const [category, setCategory] = useState({
    id: '',
    name: '',
    description: ''
  })
  const {loading, data} = useQuery(getCategoryById, {variables: {id: params.id}})

  let mutation = createCategoryMutation;
  let response_key = 'createCategory'

  if (params.id) {
    mutation = updateCategoryMutation
    response_key = 'updateCategory'

    if (!category.id && !loading && data)
      setCategory(data.category)
  }

  const [saveCall] = useMutation(mutation, {refetchQueries: [getCategories]})

  const onSubmit = (event) => {
    event.preventDefault()
    saveData({
      event: event,
      gqlCall: saveCall,
      query_key: response_key,
      flash_callback: setFlash,
      success: () => {
        navigate(`/categories`)
      }
    })
  }

  return (
    <Container>
      <PageTitle title='Mesele zilei'/>
      <form onSubmit={onSubmit}>
        <input type='hidden' name='id' id="id" defaultValue={category.id}/>

        <Row className="mb-2">
          <Col>
            <label htmlFor="name">Denumire</label>
            <input type='text' name='name' className="form-control" id="name" defaultValue={category.name}/>
          </Col>
          <Col>
            <label htmlFor="time">Interval orar</label>
            <input type='text' name='time' className="form-control" id="time" defaultValue={category.time}/>
          </Col>
        </Row>
        <Row className='mb-2'>
          <Col>
            <label htmlFor="details">Descriere</label>
            <textarea name='details' className="form-control" id="details" defaultValue={category.details}/>
          </Col>
        </Row>

        <Row className="mb-3">
          <FlashMessage flash={flash} buttons={
            <>
              <BackButton to='/categories' className='float-end' showText={true} size='md'/>
              <Button type='submit' className='float-end'>Salveaza</Button>
            </>
          }/>
        </Row>
      </form>
    </Container>
  )
};

export default CategoryForm;